import { render, staticRenderFns } from "./createReport.vue?vue&type=template&id=370da966&scoped=true&"
import script from "./createReport.vue?vue&type=script&lang=js&"
export * from "./createReport.vue?vue&type=script&lang=js&"
import style0 from "./createReport.vue?vue&type=style&index=0&id=370da966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370da966",
  null
  
)

export default component.exports